import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class RoomCategoryActivity extends Component {
    constructor(props){
        super(props)
        this.RenderedComponent = import("app/components/Hospitality/RoomCategory/RoomCategoryBrowser")
    }

    render() {
        return (
            <Activity 
                name="RoomCategory"
                context="RoomCategory"
                RenderedComponent={this.RenderedComponent}
            />
        )
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(RoomCategoryActivity)
